import { module as m } from 'modujs';
import {lerp} from "../../utils/maths";
import {transform} from "../../utils/transform";
import {StoreSingleton} from "../../singletons/store";

export default class extends m {
    constructor(m) {
        super(m);

        // VAR
        this.lastX = 0;
        this.lastY = 0;
        this.currentX = 0;
        this.currentY = 0;

        // FUNC
        this._move = this._move.bind(this);
        this.animate = this.animate.bind(this);
    }

    init() {
        if(!StoreSingleton.isMobile) {

            // MOUSE MOVE
            document.addEventListener('mousemove', this._move);

            window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
            this.animate();
        }
    }

    /**
     * DESTROY
     */
    destroy() {
        window.cancelAnimationFrame(this.requestAnimationFrame);
    }

    /**
     * Animate
     */
    animate() {

        this.lastX = (lerp(this.lastX, this.currentX, 0.2) / 4);
        this.lastY = (lerp(this.lastY, this.currentY, 0.2) / 4);
        transform(this.el, `translate3d(${-this.lastX}px, ${-this.lastY}px, 0.1px)`);

        this.requestAnimationFrame = requestAnimationFrame(this.animate);
    }

    _move(event) {
        this.currentX = (event.clientX - (document.body.clientWidth / 2));
        this.currentY = (event.clientY - (window.innerHeight / 2));
    }
}
